const flatpickr = require('flatpickr');
const ja = require('flatpickr/dist/l10n/ja.js').default.ja;

export function frm() {
  let config = {
    locale: ja,
    dateFormat: 'Y/m/d',
    defaultDate: '日付を選択',
  };
  flatpickr('.frm-calendar input', config);
}
